import { render } from "./AnnouncementManager.vue?vue&type=template&id=c1d105ee&scoped=true"
import script from "./AnnouncementManager.vue?vue&type=script&lang=js"
export * from "./AnnouncementManager.vue?vue&type=script&lang=js"

import "./AnnouncementManager.vue?vue&type=style&index=0&id=c1d105ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d105ee"]])

export default __exports__